module.exports = __webpack_public_path__ + "f0ab42c8c78dbc8abb4a4de8d6341146.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/hero.png
// module id = 561
// module chunks = 0